module.exports = __webpack_public_path__ + "img/midnight-blue.420dea61.png";